import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import PortfolioRepository from "../../../repositories/portfolio-repository";
import { PortfolioList } from "../list/interface";
import { Portfolio } from "../../../models/portfolio";

export const useGetPortfolio = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<PortfolioList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [portfolioData, setPortfolioData] = useState<Portfolio | null>(null);
  const [isOnFetchingPortfolioData, setIsOnFetchingPortfolioData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await PortfolioRepository.all(params)
      .then((response: AxiosResponse<ICollection<PortfolioList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadPortfolioData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingPortfolioData(true);

      await PortfolioRepository.show(id, params)
        .then((response: AxiosResponse<IResource<Portfolio>>) => {
          setPortfolioData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingPortfolioData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadPortfolioData,
    isOnFetchingPortfolioData,
    portfolioData,
  };
};
